import React from 'react';
import { ColorPropsEnum } from '../../types';
export var IconCoinsMoneyPlusAdd = _ref => {
  var {
    size,
    strokeWidth = 1.5,
    color = ColorPropsEnum.black
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    version: "1.1",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24h-24v-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M18.407,14.016c0.38,-0.931 0.593,-1.948 0.593,-3.016c0,-4.418 -3.582,-8 -8,-8c-4.418,0 -8,3.582 -8,8c0,4.418 3.582,8 8,8c1.068,0 2.086,-0.213 3.018,-0.593"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M11,8.132v-0.637"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M11,13.859v0.636"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M9.343,13.176c0.247,0.405 0.669,0.684 1.18,0.684h0.477h0.569c0.741,0 1.34,-0.6 1.34,-1.34c0,-0.615 -0.419,-1.15 -1.015,-1.301l-1.79,-0.45c-0.595,-0.149 -1.014,-0.684 -1.014,-1.299c0,-0.741 0.6,-1.34 1.34,-1.34h0.57h0.477c0.509,0 0.931,0.279 1.177,0.683"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M18,14c2.209,0 4,1.791 4,4c0,2.209 -1.791,4 -4,4c-2.209,0 -4,-1.791 -4,-4c0,-2.209 1.791,-4 4,-4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M16.68,18.131h2.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: strokeWidth,
    d: "M18.019,19.471v-2.68"
  })));
};
//# sourceMappingURL=IconCoinsMoneyPlusAdd.js.map